import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
// Razorpay payment integration
// You must add your Razorpay key here

import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Card,
  IconButton,
  Slide,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import paymentSuccess from "../../assets/images/Home_page_image/payment_sucess.png";
import { keyframes } from "@mui/system";
import { GenerateOrderId } from "../../utils";
import { useSelector, useDispatch } from "react-redux";
import OrderPlacedModal from "../Modal/OrderPlacedModal";
import { getLogout, resetCart } from "../../store/actions/userActions";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch } from "../../hooks";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const scaleUp = keyframes`
  from { transform: scale(0.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;
const RAZORPAY_KEY = "rzp_test_SNrGa9KRZL7eMD";
const RAZORPAY_CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";
const PaymentOptions = () => {
  // Track payment completion
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [paymentInitError, setPaymentInitError] = useState("");
  const [showSnackBar, setShowSnackBar] = useState({
    showsnack: false,
    message: "",
  });
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [isRazorpayReady, setIsRazorpayReady] = useState(
    typeof window !== "undefined" && Boolean(window.Razorpay),
  );
  const paymentMetaRef = useRef({
    razorpay_order_id: "",
    razorpay_payment_id: "",
    razorpay_signature: "",
  });
  const initiatedRazorpayOrderRef = useRef("");
  const paymentContextRef = useRef({
    order_type: "cart",
    cart_id: "",
    amount: 0,
  });
  const id = useSelector((state) => state?.user?.customerId);
  const userDetails = useSelector((state) => state?.user?.userLoginNumber);
  const orderId = GenerateOrderId(id);
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const cartItemsDetails = useSelector(
    (state) => state.user?.cartDetails || [],
  );

  console.log("cartItemsDetails PO", cartItemsDetails);
  console.log("userDetails PO", userDetails.mobile_number);

  const cartItems = useMemo(
    () => (Array.isArray(cartItemsDetails.items) ? cartItemsDetails.items : []),
    [cartItemsDetails.items],
  );
  const cartItemsRef = useRef([]);
  const finalPayAmount = useSelector((state) => state?.user?.finalPayAmount);
  const siteSettingsCharges = useSelector(
    (state) => state?.user?.siteSettingsCharges,
  );
  const platform_fee = useSelector((state) => state?.user?.platformFees);
  const delivery_partner_fee = useSelector(
    (state) => state?.user?.deliveryPartnerFees,
  );
  const gst_charges = useSelector((state) => state?.user?.gstCharges);
  const gst_charge = Number(Number(gst_charges).toFixed(2));
  const coupon_discount = useSelector((state) => state?.user?.couponAmount);
  
  useEffect(() => {
    cartItemsRef.current = cartItems;
  }, [cartItems]);
  console.log("cartItems", cartItems);

  const couponCode = useSelector((state) => state?.user?.couponCode);
  const primaryAddress = useSelector(
    (state) => state.user?.primaryAddress || [],
  );
  console.log("primaryAddress", primaryAddress);
  const addrLat = primaryAddress?.latitude;
  const addrLng = primaryAddress?.longitude;

  const userLat = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null,
  );
  const userLng = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const shop = useSelector((state) => state?.user?.shopDetails);
  const [orderStatus, setOrderStatus] = useState(null);
  const shopDistance = shop?.distance;
  let distance = 0;

  const match = shopDistance?.match(/[\d.]+/);
  if (match && shopDistance !== 0) {
    distance = parseFloat(match[0]);
  }
  const customerId = useSelector((state) => state?.user?.customerId);
  const deliveryMode = useSelector((state) => state?.user?.mode);
  const [paymentMode, setPaymentMode] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  const isListing = useMemo(
    () => cartItems?.some((item) => item.vlisting_id != null),
    [cartItems]
  );

  useEffect(() => {
    if (isListing) {
      setPaymentMode("COD");
    }
  }, [isListing]);
  const [ordersModal, setOrdersModal] = useState(false);
  const [finalOrderedData, setFinalOrderedData] = useState(false);
  const navigate = useNavigate();
  const apptoken = useSelector((state) => state?.user?.apptoken);

  const {
    data: createOrderData,
    error: createOrderError,
    fetchData: fetchCreateOrder,
  } = useFetch(BASE_URL_TEST + urls("createOrder"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: listingCreateOrderData,
    error: listingCreateOrderError,
    fetchData: fetchListingCreateOrder,
  } = useFetch(BASE_URL_TEST + urls("orderCreationForListing"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: createPaymentOrderData,
    isLoading: createPaymentOrderLoading,
    error: createPaymentOrderError,
    fetchData: fetchCreatePaymentOrder,
  } = useFetch(BASE_URL_TEST + urls("createPaymentOrder"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: verifyPaymentOrderData,
    isLoading: verifyPaymentOrderLoading,
    error: verifyPaymentOrderError,
    fetchData: fetchVerifyPaymentOrder,
  } = useFetch(BASE_URL_TEST + urls("verifyPaymentOrder"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.Razorpay) {
      setIsRazorpayReady(true);
      return;
    }

    const existingScript = document.querySelector(
      `script[src="${RAZORPAY_CHECKOUT_SRC}"]`,
    );

    if (existingScript) {
      existingScript.addEventListener("load", () => setIsRazorpayReady(true));
      existingScript.addEventListener("error", () => {
        setPaymentInitError(
          "Unable to load Razorpay checkout. Please refresh and try again.",
        );
      });
      return;
    }

    const script = document.createElement("script");
    script.src = RAZORPAY_CHECKOUT_SRC;
    script.async = true;
    script.onload = () => setIsRazorpayReady(true);
    script.onerror = () => {
      setPaymentInitError(
        "Unable to load Razorpay checkout. Please refresh and try again.",
      );
    };
    document.body.appendChild(script);
  }, []);

  const extractPaymentPayload = useCallback((paymentOrderResponse) => {
    return (
      paymentOrderResponse?.data?.data ||
      paymentOrderResponse?.data?.razorpay_order ||
      paymentOrderResponse?.data?.order ||
      paymentOrderResponse?.data ||
      paymentOrderResponse
    );
  }, []);

  const initiateRazorpayPayment = useCallback(
    (paymentOrderResponse) => {
      const responsePayload = extractPaymentPayload(paymentOrderResponse) || {};
      const razorpayOrder =
        responsePayload?.razorpay_order || responsePayload?.order || {};
      const paymentPayload = responsePayload?.payment || {};
      const razorpayOrderId =
        razorpayOrder?.id ||
        paymentPayload?.razorpay_order_id ||
        responsePayload?.razorpay_order_id ||
        responsePayload?.order_id ||
        responsePayload?.id;
      const razorpayKey =
        responsePayload?.key_id ||
        responsePayload?.razorpay_key ||
        paymentPayload?.key_id ||
        RAZORPAY_KEY;

      if (!razorpayOrderId) {
        setPaymentInitError(
          "Payment order created but order id is missing in response.",
        );
        console.error(
          "Razorpay order id missing in createPaymentOrder response",
          paymentOrderResponse,
        );
        return;
      }

      if (initiatedRazorpayOrderRef.current === razorpayOrderId) {
        return;
      }

      if (typeof window === "undefined" || !window.Razorpay) {
        setPaymentInitError(
          "Razorpay checkout is not ready yet. Please try again.",
        );
        return;
      }

      initiatedRazorpayOrderRef.current = razorpayOrderId;

      const options = {
        key: razorpayKey,
        order_id: razorpayOrderId,
        name: "Stanick",
        description: "Order Payment",
        // mobile: primaryAddress?.phone || "",
        handler: function (response) {
          const paymentMeta = {
            razorpay_order_id:
              response?.razorpay_order_id ||
              response?.data?.payment?.razorpay_order_id ||
              razorpayOrderId,
            razorpay_payment_id:
              response?.razorpay_payment_id ||
              response?.data?.payment?.razorpay_payment_id ||
              "",
            razorpay_signature:
              response?.razorpay_signature ||
              response?.data?.payment?.razorpay_signature ||
              "",
            cart_id: paymentContextRef.current?.cart_id || "",
            order_type: paymentContextRef.current?.order_type || "cart",
          };

          paymentMetaRef.current = paymentMeta;

          if (
            !paymentMeta.razorpay_order_id ||
            !paymentMeta.razorpay_payment_id ||
            !paymentMeta.razorpay_signature
          ) {
            initiatedRazorpayOrderRef.current = "";
            setPaymentInitError(
              "Payment succeeded but transaction details are incomplete. Please contact support.",
            );
            return;
          }

          fetchVerifyPaymentOrder(paymentMeta);
        },
        prefill: {
          name: primaryAddress?.name || "",
          email: primaryAddress?.email || "",
          contact: userDetails?.mobile_number?.mobile_number || ""
        },
        theme: {
          color: "#E53935",
        },
        modal: {
          ondismiss: function () {
            initiatedRazorpayOrderRef.current = "";
          },
        },
      };
      console.log("Razorpay options", options);
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        initiatedRazorpayOrderRef.current = "";
        const failure = response?.error || {};
        const failedOrderId =
          failure?.metadata?.order_id ||
          response?.error?.metadata?.order_id ||
          "";
        const description =
          failure?.description ||
          "Payment failed at gateway. Please try again.";
        setPaymentInitError(
          failedOrderId
            ? `${description} (order: ${failedOrderId})`
            : description,
        );
        console.error("Razorpay payment.failed", response);
      });

      rzp.open();
    },
    [
      extractPaymentPayload,
      fetchVerifyPaymentOrder,
      primaryAddress?.email,
      primaryAddress?.name,
      userDetails.mobile_number,
    ],
  );

  const resolveAmountInRupees = useCallback((value) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return 0;
    return Number(parsed.toFixed(2));
  }, []);

  useEffect(() => {
    if (createOrderError) {
      //  setOrderStatus("error");
      setOrderStatus("success");
    } else if (createOrderData) {
      console.log("createorder", createOrderData);
      if (createOrderData?.status === true) {
        if (paymentMode == "COD") {
          setPaymentCompleted(true);
        } else {
          setPaymentCompleted(false);
        }
        setOrderStatus("success");
      } else if (createOrderData?.status === false) {
        setOrderStatus("fail");
        //setOrderStatus("success");
      }
    }
  }, [createOrderData, createOrderError]);

  useEffect(() => {
    if (listingCreateOrderError) {
      //setOrderStatus("error");
      setOrderStatus("success");
    } else if (listingCreateOrderData) {
      console.log("createorderlisting", listingCreateOrderData);
      if (listingCreateOrderData?.status === true) {
        console.log("createorderlisting2", listingCreateOrderData?.status);
        if (paymentMode === "COD") {
          setPaymentCompleted(true);
        } else {
          setPaymentCompleted(false);
        }
        setOrderStatus("success");
      } else if (listingCreateOrderData?.status === false) {
        //setOrderStatus("fail");
        setOrderStatus("success");
      }
    }
  }, [listingCreateOrderData, listingCreateOrderError, paymentMode]);

  useEffect(() => {
    if (!createPaymentOrderData) return;

    const paymentPayload = extractPaymentPayload(createPaymentOrderData) || {};
    const nestedRazorpayOrder =
      paymentPayload?.razorpay_order || paymentPayload?.order || {};
    const nestedPayment = paymentPayload?.payment || {};
    const hasRazorpayOrderId = Boolean(
      nestedRazorpayOrder?.id ||
      nestedPayment?.razorpay_order_id ||
      paymentPayload?.razorpay_order_id ||
      paymentPayload?.order_id ||
      paymentPayload?.id,
    );

    if (createPaymentOrderData?.status === true || hasRazorpayOrderId) {
      setPaymentInitError("");
      initiateRazorpayPayment(createPaymentOrderData);
      return;
    }

    if (
      createPaymentOrderData?.status === false &&
      createPaymentOrderData?.message
    ) {
      setPaymentInitError(createPaymentOrderData?.message);
    }

     if (
      createPaymentOrderData?.message === "token is invalid" 
      
    ) {
      dispatch(getLogout());
    }
  }, [createPaymentOrderData, extractPaymentPayload, initiateRazorpayPayment]);

  useEffect(() => {
    if (verifyPaymentOrderData?.status === true && !paymentCompleted) {
      setPaymentCompleted(true);

      const orderedData = processOrdersByVendor(cartItemsRef.current);
      setFinalOrderedData(orderedData);
      setShowConfirmation(true);
      dispatch(resetCart());
    }
  }, [verifyPaymentOrderData, paymentCompleted, dispatch]);

  let isDistanceExceeded = false;
  let distanceKm = null;

  if (userLat && userLng && addrLat && addrLng) {
    distanceKm = getDistanceFromLatLonInKm(userLat, userLng, addrLat, addrLng);

    if (distanceKm > 8) {
      isDistanceExceeded = true;
    }
  }

  console.log("Distance:", distanceKm, "KM");

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Earth radius in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  const processOrdersByVendor = (items) => {
    const groupedOrders = {};

    items.forEach((item) => {
      const vendorId = item.vendor_id;

      if (!groupedOrders[vendorId]) {
        groupedOrders[vendorId] = {
          orderId: GenerateOrderId(vendorId),
          vendorId,
          items: [],
        };
      }

      groupedOrders[vendorId].items.push(item);
    });

    return Object.values(groupedOrders);
  };

  const PrepareOrderId = (items) => {
    const orderedData = processOrdersByVendor(cartItems);
    setFinalOrderedData(orderedData);
    setShowConfirmation(true);
    dispatch(resetCart());
  };

  const handleOnClose = (value) => {
    console.log("handleclose", value);

    // setShowConfirmation(false)
    setOrdersModal(false);
    navigate("/");
  };
  const PrepareFinalOrderJsonForRegular = (cartItems) => {
    const groupedOrders = {};
    cartItems.forEach((item) => {
      const vendorId = item.vendor_id;

      if (!groupedOrders[vendorId]) {
        groupedOrders[vendorId] = {
          vendor_id: vendorId,
          items: [],
          total_amount: 0,
        };
      }

      const price = item?.price;
      const originalPrice = item?.originalPrice;
      const variantOptionId = item?.variantOptionId;
      const orderItem = {
        vendor_product_id: item.vendor_product_id,
        product_id: item.product_id,
        quantity: item.quantity || 0,
        price: originalPrice,
        sellingPrice: price,
        discount: item.discount || 0,
        // variant_id: item.quantity || 0,
        variant_option_id: variantOptionId,
      };

      groupedOrders[vendorId].items.push(orderItem);

      groupedOrders[vendorId].total_amount += price * (item.quantity || 1);
    });

    const vendorOrders = Object.values(groupedOrders).map((v) => ({
      ...v,
      total_amount: v.total_amount.toString(),
      distance: distance,
    }));

    const cart_total_amount = vendorOrders.reduce(
      (sum, v) => sum + parseFloat(v.total_amount),
      0,
    );

    // const gst_charge = 0;
    // const platform_fee = 8;
    // const delivery_partner_fee = 0;
    // const coupon_discount = 0;

    const total_amount = (
      Number(cart_total_amount || 0) +
      Number(platform_fee || 0) +
      Number(delivery_partner_fee || 0) +
      Number(gst_charge || 0) -
      Number(coupon_discount || 0)
    ).toFixed(2);

    const finalOrderPayload = {
      cartItems: vendorOrders,
      user_id: customerId,
      cart_total_amount,
      gst_charge,
      platform_fee,
      delivery_partner_fee,
      coupon_discount,
      total_amount,
      coupon: couponCode ?? "",
      delivery_mode: deliveryMode,
      order_status: "PENDING",
      payment_method: paymentMode,
      notes:""
    };
    paymentContextRef.current = { 
      order_type: "cart",
      cart_id: `cart_${orderId}`,
      amount: resolveAmountInRupees(total_amount),
    };
    fetchCreateOrder(finalOrderPayload);

    console.log("finalOrderPayload", finalOrderPayload);
    return finalOrderPayload;
  };

  const PrepareFinalOrderJsonForListing = (cartItems) => {
    const groupedOrders = {};
    cartItems.forEach((item) => {
      const vendorId = item.vendor_id;

      if (!groupedOrders[vendorId]) {
        groupedOrders[vendorId] = {
          vendor_id: vendorId,
          items: [],
          total_amount: 0,
        };
      }

      const price = item?.price;
      const orderItem = {
        vlisting_id: item?.vlisting_id,
        quantity: item.quantity || 0,
        price: price,
        discount: item.discount || 0,
      };

      groupedOrders[vendorId].items.push(orderItem);

      groupedOrders[vendorId].total_amount += price * (item.quantity || 1);
    });

    const vendorOrders = Object.values(groupedOrders).map((v) => ({
      ...v,
      total_amount: v.total_amount.toString(),
      distance: distance,
    }));

    const cart_total_amount = vendorOrders.reduce(
      (sum, v) => sum + parseFloat(v.total_amount),
      0,
    );

    // const gst_charge = 0;
    // const platform_fee = 8;
    // const delivery_partner_fee = 0;
    // const coupon_discount = 0;

    // const total_amount =
    //   cart_total_amount +
    //   +platform_fee +
    //   delivery_partner_fee +
    //   gst_charge -
    //   coupon_discount;

    const total_amount = (
      Number(cart_total_amount || 0) +
      Number(platform_fee || 0) +
      Number(delivery_partner_fee || 0) +
      Number(gst_charge || 0) -
      Number(coupon_discount || 0)
    ).toFixed(2);

    const finalOrderPayload = {
      cartItems: vendorOrders,
      user_id: customerId,
      cart_total_amount,
      gst_charge,
      platform_fee,
      delivery_partner_fee,
      coupon_discount,
      total_amount,
      coupon: couponCode ?? "",
      delivery_mode: deliveryMode,
      order_status: "PENDING",
      payment_method: paymentMode,
    };
    paymentContextRef.current = {
      order_type: "listing",
      cart_id: `cart_${orderId}`,
      amount: resolveAmountInRupees(total_amount),
    };
    fetchListingCreateOrder(finalOrderPayload);
    console.log("finalOrderPayloadlisting", finalOrderPayload);
    return finalOrderPayload;
  };
  return (
    <Box sx={{ maxWidth: 1200, margin: "auto", padding: 2 }}>
      <Snackbar
        open={showSnackBar.showsnack}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Slide}
      >
        <MuiAlert severity={snackbarSeverity} sx={{ width: "100%" }}>
          {showSnackBar.message}
        </MuiAlert>
      </Snackbar>
      {!showConfirmation ? (
        <>
          {/* Check if cart has both regular and listing items */}
          {cartItems?.some((item) => item.vendor_product_id != null) &&
          cartItems?.some((item) => item.vlisting_id != null) ? (
            // Display a message if both regular and listing items are in the cart
            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Typography variant="h6" color="error">
                Your cart contains both regular and listing items. Please
                proceed with only one type at a time.
              </Typography>
              {/* Back button */}
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => navigate("/cart")}
              >
                Back to Cart
              </Button>
            </Box>
          ) : (
            <>
              {/* Back button */}
              <IconButton onClick={() => navigate("/cart")}>
                <ArrowBackIcon />
              </IconButton>

              <Typography variant="h6" gutterBottom>
                Payment Options
              </Typography>

              <Typography variant="body1">
                {cartItems?.length} Item. Total:
                <CurrencyRupeeIcon
                  sx={{ fontSize: 16, verticalAlign: "middle" }}
                />
                {finalPayAmount}
                {/* {
                  Number(cartItemsDetails?.finalPay || 0
                ).toFixed(2)} */}
              </Typography>

              {/* Delivery address */}
              <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                <LocationOnIcon color="primary" />
                <Box sx={{ ml: 1 }}>
                  <Typography variant="body2" color="primary" fontWeight="bold">
                    Delivery to Home
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {[
                      primaryAddress?.street,
                      primaryAddress?.city,
                      primaryAddress?.landmark,
                      primaryAddress?.state,
                      primaryAddress?.country,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    {primaryAddress?.pincode
                      ? ` - ${primaryAddress.pincode}`
                      : ""}
                  </Typography>
                </Box>
              </Box>
              {isDistanceExceeded && (
                <Typography
                  variant="body1"
                  sx={{ color: "red", mt: 2, fontWeight: "bold" }}
                >
                  Your current location is {distanceKm?.toFixed(2)} km away from
                  your primary address. Delivery is allowed only within 8 km.
                </Typography>
              )}
              {/* Payment mode selection */}
              <Card sx={{ padding: 2, mt: 2, backgroundColor: "#FFF8F5" }}>
                <Typography variant="subtitle1" color="error" fontWeight="bold">
                  Choose Your Payment Mode
                </Typography>
                <RadioGroup
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  sx={{ mt: 1 }}
                >
                  <FormControlLabel
                    value="COD"
                    control={<Radio color="error" />}
                    label="Cash/Pay on Delivery"
                  />
                  {/* Other payment options commented out */}
                  {!isListing && (
                    <FormControlLabel
                      value="Online"
                      control={<Radio color="error" />}
                      label="Pay Online"
                    />
                  )}
                </RadioGroup>
              </Card>

              {/* Pay button */}
              {/* Conditional Pay Button */}
              {/* Pay button with improved checks */}
              {primaryAddress &&
              Object.keys(primaryAddress).length > 0 &&
              cartItems?.[0] ? (
                <>
                  {cartItems[0]?.vendor_product_id != null ? (
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        mt: 2,
                        backgroundColor: isDistanceExceeded
                          ? "#bdbdbd"
                          : "#E53935",
                        color: "white",
                        textTransform: "none",
                        fontSize: 16,
                      }}
                      onClick={() => {
                        if (isDistanceExceeded) return;
                        if (paymentMode == "") {
                          setSnackbarSeverity("error");
                          setShowSnackBar({
                            ...showSnackBar,
                            message: "Please select payment mode",
                            showsnack: true,
                          });
                        } else {
                          PrepareOrderId(cartItems);
                          PrepareFinalOrderJsonForRegular(cartItems);
                        }
                      }}
                    >
                      {/* Pay ₹{(cartItemsDetails?.finalPay || 0).toFixed(2)} */}
                      Pay ₹{finalPayAmount}
                    </Button>
                  ) : primaryAddress &&
                    Object.keys(primaryAddress).length > 0 &&
                    cartItems?.[0]?.vlisting_id != null ? (
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        mt: 2,
                        backgroundColor: isDistanceExceeded
                          ? "#bdbdbd"
                          : "#E53935",
                        color: "white",
                        textTransform: "none",
                        fontSize: 16,
                      }}
                      onClick={() => {
                        if (isDistanceExceeded) return;
                        if (paymentMode == "") {
                          setSnackbarSeverity("error");
                          setShowSnackBar({
                            ...showSnackBar,
                            message: "Please select payment mode",
                            showsnack: true,
                          });
                        } else {
                          PrepareOrderId(cartItems);
                          PrepareFinalOrderJsonForListing(cartItems);
                        }
                      }}
                    >
                      Pay ₹{finalPayAmount}
                    </Button>
                  ) : null}
                </>
              ) : null}
            </>
          )}
        </>
      ) : orderStatus === "success" ? (
        !paymentCompleted ? (
          <Box sx={{ textAlign: "center", mt: 8 }}>
            <Typography variant="h5" color="primary">
              Please complete your payment
            </Typography>
            {createPaymentOrderError && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                Unable to create payment order. Please try again.
              </Typography>
            )}
            {createPaymentOrderData?.status === false &&
              createPaymentOrderData?.message && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {createPaymentOrderData?.message}
                </Typography>
              )}
            {paymentInitError && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {paymentInitError}
              </Typography>
            )}
            {verifyPaymentOrderError && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                Payment verification failed. Please contact support if amount
                was debited.
              </Typography>
            )}
            <Button
              variant="contained"
              sx={{ mt: 2, backgroundColor: "#E53935", color: "white" }}
              disabled={
                createPaymentOrderLoading ||
                verifyPaymentOrderLoading ||
                !isRazorpayReady
              }
              onClick={() => {
                setPaymentInitError("");
                const fallbackAmount = resolveAmountInRupees(
                  cartItemsDetails?.finalPay || 0,
                );
                const amountToPay =
                  paymentContextRef.current.amount || fallbackAmount;

                if (!amountToPay || amountToPay <= 0) {
                  setPaymentInitError(
                    "Unable to resolve amount. Please go back to cart and try again.",
                  );
                  return;
                }

                const paymentOrderPayload = {
                  order_type: paymentContextRef.current.order_type || "cart",
                  cart_id:
                    paymentContextRef.current.cart_id || `cart_${orderId}`,
                  amount: amountToPay,
                  currency: "INR",
                  receipt: orderId,
                  notes: `Payment for ${orderId}`,
                  user_id: customerId,
                };
                fetchCreatePaymentOrder(paymentOrderPayload);
              }}
            >
              {createPaymentOrderLoading || verifyPaymentOrderLoading
                ? "Processing..."
                : !isRazorpayReady
                  ? "Loading payment gateway..."
                  : "Pay Now"}
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              textAlign: "center",
              mt: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: `${fadeIn} 0.6s ease-in-out`,
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h5"
              align="center"
              sx={{ animation: `${fadeIn} 1s ease-in-out` }}
            >
              Your order has been received. Thank you!
            </Typography>
            <Box sx={{ textAlign: "center", mt: 2 }}>
              <img
                src={paymentSuccess}
                alt="Order Confirmation"
                width={250}
                style={{ animation: `${scaleUp} 0.8s ease-in-out` }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mt: 2,
                width: "100%",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#E53935",
                  mb: 1,
                  width: "40%",
                  animation: `${slideUp} 0.8s ease-in-out 0.2s forwards`,
                  opacity: 0,
                  textTransform: "none",
                }}
                onClick={() => navigate("/profileinfo")}
              >
                Track your order
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#3587e5ff",
                  mb: 1,
                  width: "40%",
                  animation: `${slideUp} 0.8s ease-in-out 0.2s forwards`,
                  opacity: 0,
                  textTransform: "none",
                  display: "none",
                }}
                onClick={() => setOrdersModal(false)}
              >
                show Order Details
              </Button>
              <Button
                variant="outlined"
                sx={{
                  width: "40%",
                  animation: `${slideUp} 0.8s ease-in-out 0.4s forwards`,
                  opacity: 0,
                  textTransform: "none",
                }}
                onClick={() => navigate("/")}
              >
                Continue to shop
              </Button>
            </Box>
            {ordersModal && (
              <OrderPlacedModal
                orderDetails={finalOrderedData}
                open={true}
                onClose={(value) => handleOnClose(value)}
              />
            )}
          </Box>
        )
      ) : orderStatus === "fail" ? (
        <Box sx={{ textAlign: "center", mt: 8 }}>
          <Typography variant="h5" color="error">
            Order failed!
          </Typography>
          <Typography variant="body1" mt={1}>
            We couldn’t place your order. Please try again later or go back to
            cart.
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => navigate("/cart")}
          >
            Back to Cart
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};
export default PaymentOptions;
